import * as XLSX from "xlsx";
import {saveWorkbook} from "../../../utils/excel";

const HEADER = ['類別', '名稱', '地址', '可施打疫苗']

export const useExportMedicalOrganizationManagement = ({
  data,
}) => {
  // export cases detail to excel file
  const exportData = () => {
    const workbook = XLSX.utils.book_new();
    const values = []
    values.push(HEADER)
    for (const row of data){
      values.push([
        row.category,
        row.name,
        row.address,
        row.vaccines.join(',')
      ])
    }

    const worksheet = XLSX.utils.aoa_to_sheet(values);
    XLSX.utils.book_append_sheet(workbook, worksheet, '總表');
    saveWorkbook({ workbook, fileName: '就醫資訊列表'})
  }
  return { exportData }
}